import { useEffect } from "react";

import { useUserPreferences } from "@/hooks/usePreferences";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { safeStorage } from "@/lib/safeStorage";

/** Applies the global theme and motion preferences to <html>. */
export function ThemeController({ enabled }: { enabled: boolean }) {
  const { data } = useUserPreferences(enabled);
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
  const theme = data?.theme ?? "system";
  const motion = data?.reduce_motion ?? "system";

  useEffect(() => {
    const resolved = theme === "system" ? (prefersDark ? "dark" : "light") : theme;
    document.documentElement.dataset.theme = resolved;
    safeStorage.set("kshop:theme", theme);
  }, [theme, prefersDark]);

  useEffect(() => {
    if (motion === "reduce") document.documentElement.dataset.motion = "reduce";
    else delete document.documentElement.dataset.motion;
  }, [motion]);

  return null;
}
